import React, { useState, useRef, useEffect } from 'react';

export const LanguageSwitcher = ({ currentLanguage, onLanguageChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Map language codes to full names
  const languageNames = {
    'et': 'Eesti',
    'en': 'English'
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle language selection
  const handleSelect = (lang) => {
    onLanguageChange(lang);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher" ref={dropdownRef} style={{ position: 'relative' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          backgroundColor: 'transparent',
          color: '#333',
          border: '1px solid #2e7d32',
          borderRadius: '4px',
          padding: '6px 12px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 'normal',
          fontSize: '14px'
        }}
      >
        {languageNames[currentLanguage]}
        <i 
          className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} 
          style={{ marginLeft: '8px', fontSize: '12px' }}
        ></i>
      </button>
      
      {isOpen && (
        <div 
          className="language-dropdown"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            backgroundColor: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            zIndex: 1000,
            marginTop: '4px',
            minWidth: '120px'
          }}
        >
          {Object.entries(languageNames).map(([code, name]) => (
            <div
              key={code}
              onClick={() => handleSelect(code)}
              style={{
                padding: '8px 16px',
                cursor: 'pointer',
                backgroundColor: currentLanguage === code ? '#f0f0f0' : 'transparent',
                color: '#333',
                borderBottom: code !== Object.keys(languageNames).pop() ? '1px solid #eee' : 'none',
                borderRadius: code === Object.keys(languageNames)[0] ? '4px 4px 0 0' : code === Object.keys(languageNames).pop() ? '0 0 4px 4px' : '0'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f9f9f9'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = currentLanguage === code ? '#f0f0f0' : 'transparent'}
            >
              {name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;